import { css } from '@emotion/react';
import {
  Accordion, useSections,
} from '~/_shared/baseComponents/accordion';
import { noop } from '~/_shared/utils/function.helpers';
import { spreadsheetColumnIdToString } from '~/_shared/utils/spreadsheet/generalSpreadsheet.helpers';
import { GroupingItemBodyContainer } from '~/grouping/components/groupingItemBody.container';
import { GroupStatusTitle } from '~/grouping/components/groupingItemsAccordion.component';
import { useMapSettingsGroupingActiveGroupColumnsSelector } from '~/store/mapSettings/grouping/mapSettingsGrouping.selectors';
import { useSpreadsheetColumns } from '~/store/matchupData/matchupDataSelectors.hook';

const headingStyle = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 12,
});

const panelStyle = css({
  padding: 0,
});

const noFilters = {};

export const GroupingKey = () => {
  const activeColumns = useMapSettingsGroupingActiveGroupColumnsSelector();
  const allColumns = useSpreadsheetColumns({ filterOutRestricted: true });

  const { toggleSection, isExpanded } = useSections<number>([0, 1]); // all columns should be expanded by default

  return (
    <Accordion>
      {activeColumns.map((column, index) => (
        <Accordion.Item
          key={spreadsheetColumnIdToString(column)}
          onToggle={() => toggleSection(index)}
          open={isExpanded(index)}
        >
          <Accordion.ItemHeading>
            <div css={headingStyle}>
              <div>
                {allColumns.find(
                  c => c.id === column.columnId && c.spreadsheetId === column.spreadsheetId
                )?.name}
              </div>
              <GroupStatusTitle groupIndex={index} />
            </div>
          </Accordion.ItemHeading>
          <Accordion.Panel css={panelStyle}>
            <GroupingItemBodyContainer
              activeFilters={noFilters}
              currentGroupColumn={column}
              isEditingDisabled
              isFilteringDisabled
              onFilterChange={noop}
            />
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
